// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cont[data-v-3c953d1a]{position:relative}.cont .grass-wrap[data-v-3c953d1a]{background-color:#97d26f}.cont .grass-bottom[data-v-3c953d1a]{position:absolute;right:-50px;bottom:10px;width:300vw;z-index:-1}@media (min-width:768px){.cont .grass-bottom[data-v-3c953d1a]{right:0;bottom:1vw;width:180vw}}@media (min-width:1024px){.cont .grass-bottom[data-v-3c953d1a]{right:0;bottom:calc(8vw - 10px);width:140vw}}@media (min-width:1024px){.cont[data-v-3c953d1a]{padding-bottom:200px}}", ""]);
// Exports
module.exports = exports;
